import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import { IDesignerProfile, IDesignerSubStyle } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';

import styles from './FAQ.module.scss';

interface IFAQProps {
  designer: IDesignerProfile;
}

const FAQ = ({ designer }: IFAQProps) => {
  const theme = useTheme();
  const { favoritePiece, loveDesign, favoriteSubStyles } = designer;

  return (
    <div className={classNames(
      styles.Container,
      theme.styles.Body
    ) }
    >
      <div className={classNames(
        theme.styles.Title2,
        styles.Title
      )}
      >
        Designer Q&amp;A
      </div>

      { favoriteSubStyles && (
        <div className={ styles.Block }>
          <p><strong>What are your favorite styles?</strong></p>
          <p>{ getFavoriteSubStyles(favoriteSubStyles) }</p>
        </div>
      )}
      <div className={ styles.Block }>
        <p><strong>Why do you love online interior design?</strong></p>
        <p>{ loveDesign }</p>
      </div>

      <div className={ styles.Block }>
        <p><strong>What is your favorite piece?</strong></p>
        <p>{ favoritePiece }</p>
      </div>
    </div>
  );
};

function getFavoriteSubStyles(favoriteSubStyles: IDesignerSubStyle[] | undefined): string {
  if (!favoriteSubStyles) return '';
  const names = favoriteSubStyles?.map((fss) => fss.name);
  const rear = names.pop();

  return `${names.join(', ')} and ${rear}`;
}

export default FAQ;
